<template>
  <div class="noticeDetails-user" :style="{ '--height': height, }">
    <div class="index-view-top">
      <van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
      <div class="title">{{ $t("head.notice") }}</div>
      <van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
    </div>
    <div class="notice-details">
      <div class="title">{{ noticelist.title }}</div>
      <div class="time">{{ noticelist.createTime }}</div>
      <div class="time" v-html="noticelist.content"></div>
    </div>
  </div>
</template>

<script>
import {
  BASEURL
} from "@/utils/http";
export default {
  data() {
    return {
      noticelist: [],
      height: '',//屏幕高度
      baseUrl: ''
    };
  },
  created() {
    let h = document.documentElement.clientHeight || document.body.clientHeight;
    if (h > 0) {
      this.height = h + 'px' //页面高度
    } else {
      this.height = "100vh"
    }
    this.baseUrl = BASEURL
    this.looknotice(this.$route.query.item);
  },
  mounted() { },
  methods: {
    looknotice(item) {
      let details = JSON.parse(item)
      let str = '<img style="max-width:100%;max-height:100%" src="' + this.baseUrl
      details.content = details.content.replace(RegExp('<img src="', "g"), str);
      this.noticelist = details;
      console.log(details.content, this.baseUrl)
    },
    toBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .time {
  overflow: hidden;
  width: 100%;
  white-space: normal;
  word-break: break-all;
}

.noticeDetails-user {
  width: 100vw;
  height: var(--height);
  background: #0c0b0b;

  .notice-details {
    padding: 0 0.9375rem;

    .title {
      font-size: 1rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      padding: 1rem 0 0.3125rem;
    }

    .time {
      font-size: 0.75rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #999999;
      padding-bottom: 1.875rem;
    }
  }

  .index-view-top {
    height: 3.625rem;
    padding: 0 0.9375rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-size: 1.125rem;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #ffffff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/notice/noticeDetails.vue